export const WorkspaceGray = (
  <svg
    width="129"
    height="24"
    viewBox="0 0 129 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.8434 19.9802C18.9468 22.047 16.6153 23.292 13.7885 23.7512C11.9161 24.0534 10.0316 23.8963 8.20748 23.2799L7.39811 23.014L12.6047 17.8167C18.1495 12.2689 18.1978 12.2084 17.8233 11.4711C17.7388 11.314 16.8931 10.3954 15.9509 9.42849C14.1147 7.56713 13.9335 7.26497 14.1872 6.49142C14.2717 6.2376 15.057 5.36735 16.422 4.00155L18.5361 1.88638L19.0555 2.23689C20.5051 3.19174 22.2568 5.39153 23.0057 7.19245C23.7668 9.00545 23.9118 9.76692 23.8997 11.9667C23.8997 13.7797 23.8755 14.0577 23.5735 15.0367C22.9453 17.1036 22.148 18.554 20.8434 19.9802ZM8.09876 14.5049C9.77791 16.185 10.0074 16.5355 9.87455 17.2365C9.83831 17.4903 9.1739 18.2397 7.62763 19.7989L5.44111 22.0108L4.45054 21.213C1.39424 18.7594 -0.369467 14.5895 0.0654207 10.8305C0.403666 7.91765 1.39424 5.75413 3.36332 3.67521C5.00623 1.93473 6.95114 0.834833 9.40342 0.242584C10.6598 -0.0595844 13.1845 -0.083758 14.4046 0.194237C15.4677 0.435971 16.4945 0.750226 16.4945 0.834833C16.4945 0.88318 14.2355 3.16757 11.4691 5.92334C8.71485 8.67911 6.37129 11.0844 6.27465 11.2657C6.0572 11.6766 6.0572 12.1359 6.27465 12.5469C6.37129 12.7282 7.19274 13.6105 8.09876 14.5049ZM76.2703 18.9212L71.5102 13.444L75.5733 8.74361H72.3467L69.2197 12.7469V2.60919H66.6106V18.9212H69.2197V14.4598L72.9442 18.9212H76.2703ZM56.7847 13.8623C56.7847 10.9146 54.4345 8.44486 51.3275 8.44486C48.1607 8.44486 45.7507 10.8548 45.7507 13.8623C45.7507 16.8498 48.1607 19.2199 51.2677 19.2199C54.3548 19.2199 56.7847 16.81 56.7847 13.8623ZM51.2478 17.1884C49.8138 17.1884 48.4793 15.8141 48.4793 13.922C48.4793 11.9303 49.6943 10.5561 51.3275 10.5561C52.8013 10.5561 54.0362 11.9303 54.0362 13.8623C54.0362 15.854 52.9208 17.1884 51.2478 17.1884ZM41.1483 19.1203L45.4106 8.74361H42.682L40.272 14.7984L37.8421 8.80336H37.3641L34.9143 14.7187L32.5442 8.74361H29.7957L34.0579 19.1203H35.3923L37.6031 13.4838L39.8338 19.1203H41.1483ZM61.2565 13.3046V18.9212H58.6673V8.74361H61.2565V10.3569C61.4955 9.83904 62.2922 8.46477 63.4872 8.46477C64.4034 8.46477 64.9013 8.7237 65.3196 8.9627L64.4233 11.4125C64.1047 11.1934 63.6665 10.8946 63.0292 10.8946C61.874 10.8946 61.2565 12.2888 61.2565 13.3046ZM80.4409 19.2398C78.6285 19.2398 77.314 18.5428 76.4974 17.9452L77.4534 16.0731C78.0708 16.6706 79.3057 17.288 80.2617 17.288C80.8791 17.288 81.5961 17.0291 81.5961 16.1328C81.5961 15.5694 80.8378 15.1231 79.9521 14.602C78.7087 13.8703 77.2144 12.991 77.2144 11.4324C77.2144 9.85896 78.6086 8.40502 80.7596 8.40502C82.6318 8.40502 83.7671 9.18179 84.2451 9.56021L83.309 11.3527C83.1297 11.1536 82.1936 10.3768 81.2177 10.3768C80.5405 10.3768 79.9629 10.7154 79.9629 11.293C79.9629 11.9516 80.7362 12.3883 81.627 12.8914C82.8375 13.5749 84.265 14.3811 84.265 16.0332C84.265 18.005 82.7712 19.2398 80.4409 19.2398ZM88.8014 24V18.3237C89.4786 18.8216 90.5342 19.2 91.3308 19.2C94.5176 19.2 96.2902 16.6108 96.2902 13.8025C96.2902 10.2175 93.6213 8.44486 90.7533 8.44486C89.3392 8.44486 87.6263 8.80336 86.1923 9.58012V24H88.8014ZM88.8014 11.0141C89.2197 10.7552 89.9566 10.6158 90.5541 10.6158C92.4263 10.6158 93.5217 11.9901 93.5217 13.8224C93.5217 15.7743 92.4263 17.049 91.1317 17.049C90.2753 17.049 89.4985 16.8697 88.8014 15.8938V11.0141ZM102.205 17.288C103.002 17.288 103.679 17.1287 104.137 16.8697V14.898C103.719 14.5394 102.862 14.161 102.026 14.161C101.03 14.161 100.134 14.6589 100.134 15.5552C100.134 16.6108 100.93 17.288 102.205 17.288ZM102.344 8.44486C105.73 8.44486 106.626 10.0581 106.626 12.5677V17.9652C105.85 18.5826 104.356 19.2199 102.006 19.2199C98.8787 19.2199 97.4447 17.4872 97.4447 15.5154C97.4447 13.1851 99.6754 12.3087 101.587 12.3087C102.285 12.3087 103.559 12.5478 104.137 12.9859V11.9502C104.137 11.1137 103.519 10.5361 102.125 10.5361C100.811 10.5361 99.6953 10.9544 99.297 11.1336L98.5402 9.30129C99.4563 8.86311 100.711 8.44486 102.344 8.44486ZM116.853 16.0332C116.554 16.332 115.399 17.1087 114.005 17.1087C112.351 17.1087 111.017 15.7345 111.017 13.8623C111.017 11.8108 112.451 10.576 114.025 10.576C115.2 10.576 116.116 11.1934 116.434 11.4722L117.331 9.60004C116.972 9.28137 115.598 8.44486 113.905 8.44486C110.738 8.44486 108.348 10.7552 108.348 13.8424C108.348 16.8299 110.619 19.2199 113.626 19.2199C115.937 19.2199 117.271 18.2241 117.669 17.8257L116.853 16.0332ZM124.646 17.1486C126.199 17.1486 127.295 16.5112 127.673 16.1527L128.43 17.9652C127.892 18.4233 126.338 19.2199 124.068 19.2199C120.702 19.2199 118.431 17.1287 118.431 13.8623C118.431 10.7552 120.702 8.44486 123.869 8.44486C127.175 8.44486 128.808 10.9544 128.808 13.8224V14.8183H121.061C121.339 16.7104 123.052 17.1486 124.646 17.1486ZM123.889 10.4764C122.395 10.4764 121.359 11.3727 121.061 12.8664H126.199C126.179 11.5718 125.303 10.4764 123.889 10.4764Z"
      fill="black"
    />
  </svg>
);

export const IconTickBlack = (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.94996 0.44405C9.92433 0.420431 9.89438 0.402206 9.86183 0.390421C9.82928 0.378635 9.79478 0.37352 9.76029 0.375369C9.7258 0.377218 9.69201 0.385994 9.66085 0.401195C9.62969 0.416395 9.60178 0.437722 9.57871 0.463952L4.15168 6.59683L1.33391 3.99962C1.30833 3.97595 1.27841 3.95767 1.24589 3.94582C1.21337 3.93397 1.17888 3.92879 1.1444 3.93057C1.10991 3.93234 1.0761 3.94105 1.04492 3.95618C1.01373 3.97131 0.98578 3.99258 0.96266 4.01875L0.317656 4.74671C0.294513 4.77287 0.276657 4.80344 0.265109 4.83666C0.253562 4.86987 0.24855 4.90509 0.250361 4.94029C0.252173 4.97549 0.260772 5.00998 0.275666 5.04178C0.290559 5.07358 0.311455 5.10207 0.337156 5.12561L4.05718 8.55488C4.09302 8.58766 4.13723 8.60942 4.18468 8.61765C4.23046 8.62889 4.27839 8.62721 4.32331 8.61278C4.36823 8.59836 4.40846 8.57172 4.43968 8.53574L10.6827 1.48048C10.7292 1.42768 10.7533 1.3582 10.7496 1.2873C10.746 1.2164 10.7149 1.14987 10.6632 1.10235L9.94996 0.44405Z"
      fill="black"
      stroke="black"
      strokeWidth="0.5"
    />
  </svg>
);

export const IconWorkerMale = (
  <svg
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M45.0029 42.8104L45.0036 42.8098C49.0252 38.3563 51.5 32.4461 51.5 26C51.5 22.8085 50.9191 19.8017 49.8027 16.9868C47.4228 10.7328 42.5725 5.74667 36.5164 3.08454L36.5144 3.0837C33.4096 1.72667 30.061 1 26.4767 1C21.5731 1 17.015 2.45569 13.144 4.8727L13.144 4.87269L13.1398 4.87535C6.15738 9.28356 1.5 17.0848 1.5 26C1.5 33.0218 4.36132 39.3215 9.01329 43.874C10.907 45.765 13.0928 47.3177 15.5209 48.4823C18.8169 50.0799 22.5497 51 26.4767 51C33.7974 51 40.4425 47.8512 45.0029 42.8104Z"
      fill="url(#paint0_linear_4932_9695)"
      fillOpacity="0.14"
      stroke="url(#paint1_radial_4932_9695)"
      strokeWidth="2"
    />
    <path
      d="M38.3953 22.604C38.3953 24.0924 37.1848 25.3482 35.6484 25.3482C35.4156 25.3482 35.1829 25.3017 34.9966 25.2552C34.2517 27.4412 32.9481 29.2552 31.3186 30.418C30.015 31.3482 28.5252 31.8598 26.8957 31.8598C26.6164 31.8598 26.3371 31.8598 26.1043 31.8133C24.6145 31.6738 23.2178 31.0226 22.0539 30.0924C21.4486 29.6273 20.8899 29.0226 20.4244 28.3715C19.726 27.4412 19.2139 26.418 18.7949 25.2552C18.5621 25.3482 18.3293 25.3482 18.05 25.3482C16.5601 25.3482 15.3031 24.1389 15.3031 22.604C15.3031 21.0691 16.5136 19.8598 18.05 19.8598C18.0965 19.8598 18.1431 19.8598 18.2362 19.8598C18.7949 14.6505 22.4729 10.604 26.8957 10.604C31.3652 10.604 35.0432 14.6505 35.5553 19.8598C35.6019 19.8598 35.6018 19.8598 35.6484 19.8598C37.1382 19.9063 38.3953 21.1156 38.3953 22.604Z"
      fill="#FFCCCC"
    />
    <path
      d="M31.3186 30.418V34.1854C31.3186 34.418 31.3186 34.6505 31.2721 34.8831C30.9462 37.1156 29.0373 38.8366 26.6629 38.8366C24.8938 38.8366 23.404 37.8598 22.6125 36.418L26.1043 31.8133C26.3836 31.8598 26.6629 31.8598 26.8957 31.8598C28.4787 31.9063 30.015 31.3482 31.3186 30.418Z"
      fill="#FFCCCC"
    />
    <path
      d="M44.2615 42.139C42.9579 43.5808 41.4681 44.8367 39.8852 45.9529C39.6058 46.139 39.373 46.325 39.0937 46.4646C35.8813 48.4181 32.2033 49.6739 28.1994 49.9529C27.8735 49.9994 27.5942 49.9995 27.2683 49.9995C27.0355 49.9995 26.7562 49.9995 26.4768 49.9995C22.7057 49.9995 19.1208 49.1157 15.955 47.5808C13.6271 46.4646 11.5321 44.9762 9.7164 43.1622C11.9046 41.0692 14.5583 38.9762 17.5845 37.3483C18.0966 37.0692 18.6087 36.7902 19.1674 36.5576C20.1451 36.0925 21.1228 35.7204 22.1936 35.3948C22.7057 37.3948 24.5214 38.8832 26.7096 38.8832C29.0374 38.8832 30.9928 37.1622 31.3187 34.9297C32.5757 35.2553 33.7862 35.6274 34.9036 36.139C38.535 37.5808 41.7009 39.8134 44.2615 42.139Z"
      fill="url(#paint2_radial_4932_9695)"
    />
    <path
      d="M26.6632 39.07C24.4284 39.07 22.5196 37.5816 21.9609 35.442L22.4265 35.3025C22.9386 37.256 24.7078 38.6048 26.7097 38.6048C28.8979 38.6048 30.7601 36.9769 31.086 34.8374L31.5516 34.8839C31.1326 37.3025 29.0841 39.07 26.6632 39.07Z"
      fill="#000002"
    />
    <path
      d="M17.6773 19.9072C17.6773 19.9072 17.7705 10.0002 24.8936 10.8839L24.3815 12.1397C24.3815 12.1397 19.3534 13.6281 18.236 19.8607L17.6773 19.9072Z"
      fill="#050004"
    />
    <path
      d="M23.8227 11.8605C23.8227 11.8605 27.5938 17.907 33.2271 15.3953C33.2271 15.3953 33.972 19.9535 34.7635 19.907C35.555 19.907 35.555 19.907 35.555 19.907C35.555 19.907 36.1136 12.6511 31.0855 10.1395C26.0574 7.58138 23.8227 11.8605 23.8227 11.8605Z"
      fill="#050004"
    />
    <path
      d="M27.3152 23.0234C26.7565 23.0234 26.3375 22.5583 26.3375 22.0467V19.6281C26.3375 19.4885 26.4306 19.3955 26.5703 19.3955C26.71 19.3955 26.8031 19.4885 26.8031 19.6281V22.0467C26.8031 22.3257 27.0359 22.5583 27.3152 22.5583C27.4549 22.5583 27.548 22.6513 27.548 22.7909C27.548 22.9304 27.4083 23.0234 27.3152 23.0234Z"
      fill="#050004"
    />
    <path
      d="M26.709 25.3488C26.6625 25.3488 26.6625 25.3488 26.709 25.3488C26.5228 25.3488 26.4297 25.2558 26.4297 25.1163C26.4297 24.9767 26.5228 24.8837 26.6625 24.8837C26.7556 24.8837 29.4559 24.9767 29.549 22.4186C29.549 22.2791 29.6887 22.186 29.7818 22.186C29.9214 22.186 30.0146 22.3256 30.0146 22.4186C29.8749 25.2558 27.0815 25.3488 26.709 25.3488Z"
      fill="#050004"
    />
    <path
      d="M18.7949 23.2559C18.7483 23.2559 18.7018 23.2559 18.6552 23.2093C18.0034 22.7442 17.1188 23.2093 17.0723 23.2093C16.9792 23.2559 16.8395 23.2093 16.7464 23.1163C16.6998 23.0233 16.7464 22.8838 16.8395 22.7907C16.8861 22.7442 18.05 22.1396 18.888 22.7907C18.9811 22.8838 19.0277 23.0233 18.9346 23.1163C18.9346 23.2093 18.8414 23.2559 18.7949 23.2559Z"
      fill="#050004"
    />
    <path
      d="M35.1828 23.2552C35.0897 23.2552 35.0431 23.2087 34.9966 23.1622C34.95 23.0692 34.95 22.9297 35.0897 22.8366C36.114 22.1855 37.0916 22.7901 37.1382 22.8366C37.2313 22.8832 37.2779 23.0692 37.2313 23.1622C37.1848 23.2552 36.9985 23.3018 36.9054 23.2552C36.8589 23.2552 36.114 22.7901 35.3225 23.2552C35.2759 23.2087 35.2294 23.2552 35.1828 23.2552Z"
      fill="#050004"
    />
    <path
      d="M23.2712 19.0756C23.8823 18.6487 24.1865 18.0295 23.9507 17.6927C23.715 17.3559 23.0284 17.429 22.4174 17.8559C21.8063 18.2828 21.5021 18.9019 21.7378 19.2388C21.9736 19.5756 22.6601 19.5025 23.2712 19.0756Z"
      fill="#050004"
    />
    <path
      d="M32.0076 18.6932C32.1524 18.3085 31.7039 17.7841 31.006 17.522C30.308 17.2598 29.6249 17.3592 29.4801 17.7439C29.3353 18.1286 29.7838 18.6529 30.4817 18.9151C31.1796 19.1772 31.8628 19.0779 32.0076 18.6932Z"
      fill="#050004"
    />
    <path
      d="M23.311 21.1632C23.6196 21.1632 23.8697 20.9133 23.8697 20.605C23.8697 20.2968 23.6196 20.0469 23.311 20.0469C23.0025 20.0469 22.7523 20.2968 22.7523 20.605C22.7523 20.9133 23.0025 21.1632 23.311 21.1632Z"
      fill="#050004"
    />
    <path
      d="M30.1079 21.0235C30.4165 21.0235 30.6666 20.7736 30.6666 20.4654C30.6666 20.1571 30.4165 19.9072 30.1079 19.9072C29.7994 19.9072 29.5492 20.1571 29.5492 20.4654C29.5492 20.7736 29.7994 21.0235 30.1079 21.0235Z"
      fill="#050004"
    />
    <path
      d="M26.0575 31.8606L22.5657 36.4652C22.3795 36.1397 22.2398 35.7676 22.1467 35.3955C22.0536 35.0234 22.007 34.6513 22.007 34.2327V30.1396C23.2175 31.0699 24.5677 31.6745 26.0575 31.8606Z"
      fill="#050004"
    />
    <path
      d="M26.8491 32.0932C23.7298 32.0932 21.9606 30.3258 21.8675 30.2328C21.7744 30.1397 21.7744 30.0002 21.8675 29.9072C21.9606 29.8141 22.1003 29.8141 22.1934 29.9072C22.1934 29.9072 24.3815 32.0467 28.0595 31.5351C28.1992 31.5351 28.2923 31.5816 28.3389 31.7211C28.3389 31.8607 28.2923 31.9537 28.1526 32.0002C27.6871 32.0932 27.2215 32.0932 26.8491 32.0932Z"
      fill="#050004"
    />
    <path
      d="M22.6594 24.2787C23.3536 24.2787 23.9164 23.7165 23.9164 23.0229C23.9164 22.3293 23.3536 21.7671 22.6594 21.7671C21.9651 21.7671 21.4023 22.3293 21.4023 23.0229C21.4023 23.7165 21.9651 24.2787 22.6594 24.2787Z"
      fill="black"
      fillOpacity="0.1"
    />
    <path
      d="M16.514 45.3489C16.3743 45.3489 16.2812 45.3024 16.1881 45.2094C16.0019 45.0233 16.0019 44.7442 16.1881 44.5582L17.7245 43.0233C17.9107 42.8373 18.19 42.8373 18.3763 43.0233C18.5625 43.2094 18.5625 43.4884 18.3763 43.6745L16.8399 45.2094C16.7468 45.3024 16.6071 45.3489 16.514 45.3489Z"
      fill="white"
    />
    <path
      d="M18.8418 39.0236C18.7021 39.0236 18.5159 38.9306 18.4693 38.7911L17.1192 36.6515C16.9795 36.419 17.0261 36.1399 17.2588 36.0004C17.4916 35.8608 17.771 35.9073 17.9107 36.1399L19.2608 38.2794C19.4005 38.512 19.3539 38.7911 19.1211 38.9306C19.028 39.0236 18.9349 39.0236 18.8418 39.0236Z"
      fill="white"
    />
    <path
      d="M28.1999 47.5808V49.9529C27.874 49.9994 27.5947 49.9994 27.2688 49.9994V47.5808C27.2688 47.3483 27.5015 47.1157 27.7343 47.1157C28.0137 47.1157 28.1999 47.3018 28.1999 47.5808Z"
      fill="white"
    />
    <path
      d="M24.0557 44.7442C23.916 44.7442 23.7298 44.6511 23.6833 44.5116C23.5436 44.279 23.5901 44 23.8229 43.8604L26.2904 42.3256C26.5232 42.186 26.8026 42.2325 26.9422 42.4651C27.0819 42.6976 27.0353 42.9767 26.8025 43.1162L24.335 44.6511C24.1954 44.6977 24.1488 44.7442 24.0557 44.7442Z"
      fill="white"
    />
    <path
      d="M34.2987 43.8136C34.159 43.8136 33.9728 43.7205 33.8797 43.581L32.3898 41.0229C32.2502 40.7903 32.3433 40.5112 32.5761 40.3717C32.8089 40.2322 33.0882 40.3252 33.2279 40.5578L34.7177 43.1159C34.8573 43.3485 34.7643 43.6275 34.5315 43.7671C34.4849 43.8136 34.3918 43.8136 34.2987 43.8136Z"
      fill="white"
    />
    <path
      d="M37.4643 39.3018C37.3246 39.3018 37.185 39.2088 37.0918 39.1158C36.9522 38.8832 36.9987 38.6041 37.2315 38.4646L40.0249 36.5111C40.2577 36.3716 40.537 36.4181 40.6767 36.6506C40.8164 36.8832 40.7698 37.1623 40.537 37.3018L37.7436 39.2553C37.6505 39.2553 37.5574 39.3018 37.4643 39.3018Z"
      fill="white"
    />
    <path
      d="M39.0936 46.4642L38.0694 45.4875C37.8831 45.3014 37.8831 45.0224 38.0694 44.8363C38.2556 44.6503 38.5349 44.6503 38.7212 44.8363L39.9316 45.9526L39.0936 46.4642Z"
      fill="white"
    />
    <path
      d="M23.0312 24.0004C21.5414 24.0004 20.2844 22.3725 20.2844 20.3725C20.2844 18.3725 21.4949 16.7446 23.0312 16.7446C24.5211 16.7446 25.7781 18.3725 25.7781 20.3725C25.7781 22.3725 24.5211 24.0004 23.0312 24.0004ZM23.0312 17.2563C21.7742 17.2563 20.7499 18.6516 20.7499 20.419C20.7499 22.1865 21.7742 23.5818 23.0312 23.5818C24.2883 23.5818 25.3125 22.1865 25.3125 20.419C25.3125 18.6516 24.2883 17.2563 23.0312 17.2563Z"
      fill="white"
    />
    <path
      d="M30.3875 24.0004C28.8976 24.0004 27.6406 22.3725 27.6406 20.3725C27.6406 18.3725 28.8511 16.7446 30.3875 16.7446C31.8773 16.7446 33.1343 18.3725 33.1343 20.3725C33.1343 22.3725 31.8773 24.0004 30.3875 24.0004ZM30.3875 17.2563C29.1304 17.2563 28.1062 18.6516 28.1062 20.419C28.1062 22.1865 29.1304 23.5818 30.3875 23.5818C31.6445 23.5818 32.6687 22.1865 32.6687 20.419C32.6687 18.6516 31.5979 17.2563 30.3875 17.2563Z"
      fill="white"
    />
    <path
      d="M27.5475 16.2326C27.5009 16.2326 27.5009 16.2326 27.4543 16.2326C23.8695 14.6512 24.1488 12.2326 24.1488 12.1396C24.1488 12 24.2885 11.907 24.4282 11.9535C24.5678 11.9535 24.661 12.093 24.6144 12.2326C24.6144 12.3256 24.3816 14.4186 27.6406 15.8605C27.7803 15.907 27.8268 16.0465 27.7803 16.1861C27.7337 16.1861 27.6406 16.2326 27.5475 16.2326Z"
      fill="#050004"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4932_9695"
        x1="2.5"
        y1="22.7898"
        x2="50.5"
        y2="29.5491"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0643D0" />
        <stop offset="0.451702" stop-color="#2D7CF9" />
        <stop offset="0.863185" stop-color="#F92DD8" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_4932_9695"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.30672 49.2019) rotate(0.730415) scale(62.6068 62.6113)"
      >
        <stop stop-color="#0099FF" />
        <stop offset="0.6098" stop-color="#A033FF" />
        <stop offset="0.9348" stop-color="#FF5280" />
        <stop offset="1" stop-color="#FF7061" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_4932_9695"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.297 49.7489) rotate(0.318646) scale(45.0544 19.6583)"
      >
        <stop stop-color="#0099FF" />
        <stop offset="0.6098" stop-color="#A033FF" />
        <stop offset="0.9348" stop-color="#FF5280" />
        <stop offset="1" stop-color="#FF7061" />
      </radialGradient>
    </defs>
  </svg>
);

export const IconUntick = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="white" />
    <circle
      cx="12"
      cy="12"
      r="11"
      stroke="black"
      stroke-opacity="0.12"
      strokeWidth="2"
    />
    <path
      d="M16.45 8.31905C16.4243 8.29543 16.3944 8.27721 16.3618 8.26542C16.3293 8.25363 16.2948 8.24852 16.2603 8.25037C16.2258 8.25222 16.192 8.26099 16.1609 8.27619C16.1297 8.2914 16.1018 8.31272 16.0787 8.33895L10.6517 14.4718L7.83391 11.8746C7.80833 11.851 7.77841 11.8327 7.74589 11.8208C7.71337 11.809 7.67888 11.8038 7.6444 11.8056C7.60991 11.8073 7.5761 11.816 7.54492 11.8312C7.51373 11.8463 7.48578 11.8676 7.46266 11.8938L6.81766 12.6217C6.79451 12.6479 6.77666 12.6784 6.76511 12.7117C6.75356 12.7449 6.74855 12.7801 6.75036 12.8153C6.75217 12.8505 6.76077 12.885 6.77567 12.9168C6.79056 12.9486 6.81146 12.9771 6.83716 13.0006L10.5572 16.4299C10.593 16.4627 10.6372 16.4844 10.6847 16.4926C10.7305 16.5039 10.7784 16.5022 10.8233 16.4878C10.8682 16.4734 10.9085 16.4467 10.9397 16.4107L17.1827 9.35548C17.2292 9.30268 17.2533 9.2332 17.2496 9.1623C17.246 9.0914 17.2149 9.02487 17.1632 8.97735L16.45 8.31905Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const IconTickPurple = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#5345F6" />
    <path
      d="M16.45 8.31905C16.4243 8.29543 16.3944 8.27721 16.3618 8.26542C16.3293 8.25363 16.2948 8.24852 16.2603 8.25037C16.2258 8.25222 16.192 8.26099 16.1609 8.27619C16.1297 8.2914 16.1018 8.31272 16.0787 8.33895L10.6517 14.4718L7.83391 11.8746C7.80833 11.851 7.77841 11.8327 7.74589 11.8208C7.71337 11.809 7.67888 11.8038 7.6444 11.8056C7.60991 11.8073 7.5761 11.816 7.54492 11.8312C7.51373 11.8463 7.48578 11.8676 7.46266 11.8938L6.81766 12.6217C6.79451 12.6479 6.77666 12.6784 6.76511 12.7117C6.75356 12.7449 6.74855 12.7801 6.75036 12.8153C6.75217 12.8505 6.76077 12.885 6.77567 12.9168C6.79056 12.9486 6.81146 12.9771 6.83716 13.0006L10.5572 16.4299C10.593 16.4627 10.6372 16.4844 10.6847 16.4926C10.7305 16.5039 10.7784 16.5022 10.8233 16.4878C10.8682 16.4734 10.9085 16.4467 10.9397 16.4107L17.1827 9.35548C17.2292 9.30268 17.2533 9.2332 17.2496 9.1623C17.246 9.0914 17.2149 9.02487 17.1632 8.97735L16.45 8.31905Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>
);

export const IconMacPC = (
  <svg
    width="179"
    height="120"
    viewBox="0 0 179 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="11.2905"
      y="0.75"
      width="155.797"
      height="105.527"
      rx="8.97973"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.3663 38H95.1394C93.4421 38.2248 91.6706 39.2351 90.7043 40.3705C89.6624 41.5888 88.8025 43.1499 88.9538 45.3742C91.2211 45.5527 92.6229 44.3766 93.6466 43.1639C94.6899 41.9429 95.5483 40.2567 95.3663 38ZM102 61.5522V61.489C99.7818 60.4323 98.006 58.6393 97.7596 55.5747C97.4823 52.2009 99.1054 50.2253 101.158 48.9143C100.094 47.245 98.3715 46.163 95.9446 45.7948C94.0803 45.5133 92.6313 46.045 91.19 46.574C91.0701 46.6179 90.9503 46.6619 90.8303 46.7054C90.7006 46.7529 90.5713 46.8052 90.4422 46.8574C90.0405 47.0199 89.6415 47.1813 89.2409 47.193C88.6287 47.2117 87.9898 46.9389 87.4247 46.6975C87.2684 46.6308 87.1178 46.5665 86.975 46.5115C86.279 46.2473 85.485 45.9803 84.7077 45.8595C82.8942 45.5812 81.2655 46.2037 80.0808 46.9344C77.8359 48.3087 76.147 51.1442 76 54.6318V56.0637C76.3473 60.9368 78.214 64.7447 80.6298 67.6927C81.449 68.6904 82.5735 69.7977 83.9669 70H84.6139C85.4248 69.8853 86.0976 69.6249 86.7642 69.3668C87.6575 69.021 88.5397 68.6795 89.7282 68.6988C90.7042 68.7156 91.5093 69.0297 92.3077 69.3411C93.1143 69.6557 93.914 69.9677 94.8761 69.9677C96.9832 69.9677 98.2087 68.2657 99.1946 66.8963C99.2453 66.8259 99.2953 66.7564 99.3448 66.6881C100.454 65.148 101.363 63.4885 102 61.5522Z"
      fill="black"
    />
    <rect
      x="0.75"
      y="112.642"
      width="176.878"
      height="6.60811"
      rx="2.49324"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const IconWindowsPC = (
  <svg
    width="179"
    height="120"
    viewBox="0 0 179 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="11.2905"
      y="0.75"
      width="155.797"
      height="105.527"
      rx="8.97973"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M87.3669 42.1974C92.4173 41.4266 97.4773 40.7005 102.537 40C102.541 44.4236 102.537 48.844 102.541 53.2675C97.4837 53.2867 92.4269 53.3635 87.3669 53.3795C87.3637 49.65 87.3637 45.9237 87.3669 42.1974ZM74.5405 43.9822C78.3436 43.3968 82.1629 42.8915 85.982 42.4149C85.9852 46.0836 85.9852 49.7491 85.9884 53.4179C82.1725 53.4147 78.3564 53.4722 74.5405 53.4626V43.9822ZM74.5405 54.6173C78.3535 54.6045 82.1658 54.6653 85.9785 54.6589C85.9785 58.3372 85.9881 62.0155 85.982 65.6938C82.1726 65.1306 78.3564 64.6383 74.5405 64.1234V54.6173ZM87.3445 54.7644H102.537C102.544 59.1752 102.537 63.586 102.537 68C97.4869 67.2451 92.4269 66.5447 87.3669 65.8605C87.3605 62.1627 87.3509 58.4652 87.3445 54.7644Z"
      fill="black"
    />
    <rect
      x="0.75"
      y="112.642"
      width="176.878"
      height="6.60811"
      rx="2.49324"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
